const comorbidities = {
  kidneyStoneS                       : 'Kidney Stones',
  frequentUrinaryTractInfectionsUtIs : 'Frequent Urinary Tract Infections(UTIs)',
  herniaS                            : 'Hernia',
  heartValveAbnormalities            : 'Heart Valve Abnormalities',
  aBrainCerebralAneurysm             : 'A Brain Cerebral Aneurysm',
  depression                         : 'Depression',
  polycysticLiverDiseasePld          : 'Polycystic Live Disease(PLD)',
  infertility                        : 'Infertility',
  diverticulosis                     : 'Diverticulosis',
};
const liverCystComorbidities = {
  kidney_cysts               : 'Kidney Cysts',
  liver_cysts                : 'Liver Cysts',
  pancreatic_cysts           : 'Pancreatic Cysts',
  other_cysts_please_specify : 'Other Cysts (please specify)',
  not_sure                   : '',
};

export const getComorbidities = (coreQuestionnaire) => {
  const otherComorbidities = [];
  const otherComorbiditiesEntries =
    coreQuestionnaire?.taskEntry
      ?.haveYouEverBeenToldByYourDoctorThatYouHaveSelectAllThatApply;

  for (const key in otherComorbiditiesEntries) {
    const entry = otherComorbiditiesEntries[key];
    if (entry) {
      otherComorbidities.push(comorbidities[key]);
    }
  }

  const liverCyst =
  coreQuestionnaire?.taskEntry
    ?.doYouHaveAnyCystsSelectAllThatApply;

  for (const key in liverCyst) {
    const entry = liverCyst[key];
    if (entry && key !== 'not_sure') {
      otherComorbidities.push(liverCystComorbidities[key]);
    }
  }

  const hyperTension =
  coreQuestionnaire?.taskEntry
    ?.haveYouEverBeenToldByYourDoctorThatYouHaveHighBloodPressureHypertension;
  if (hyperTension && hyperTension.toLowerCase() === 'yes') {
    otherComorbidities.push('Hypertension');
  }

  return otherComorbidities;
};
